module.exports = __webpack_public_path__ + "img/pascal-obispo.18fafbc2.jpg";